import { PayloadAction } from '@reduxjs/toolkit';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { ProductState } from 'store/product/types';

interface SelectBundleProductActionPayload {
  bundleGroupId: number;
  productItem: AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.IProductItem;
  useMultipleSelection: boolean;
  categoryId: number;
}

const selectBundleProductReducer = (state: ProductState, action: PayloadAction<SelectBundleProductActionPayload>) => {
  const { bundleGroupId, productItem, useMultipleSelection, categoryId } = action.payload;
  const alreadySelected = state.selectedBundleProducts.find(
    (sp) => sp.bundleGroupId === bundleGroupId && sp.productId === productItem.productId,
  );
  if (alreadySelected) {
    return;
  }
  // remove none option
  let updatedSelectedBundledProduts = state.selectedBundleProducts.filter(
    (sp) => !(sp.bundleGroupId === bundleGroupId && sp.productId === 0),
  );

  if (!useMultipleSelection) {
    // remove already selected options
    updatedSelectedBundledProduts = state.selectedBundleProducts.filter((sp) => sp.bundleGroupId !== bundleGroupId);
  }
  updatedSelectedBundledProduts.push({
    bundleGroupId,
    productId: productItem.productId,
    categoryId,
  });

  state.selectedBundleProducts = updatedSelectedBundledProduts;
};

export default selectBundleProductReducer;
